import React from 'react';
import { Form as AntForm } from 'antd';
import type { FormProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Form (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-form` class hook.
 * Generic on the form values type so callers keep their `onFinish` narrowing.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Form = <Values = any,>({
  className,
  ...props
}: FormProps<Values>) => {
  // antd's <Form> function signature types `children` as ReactNode, but FormProps
  // widens it to `ReactNode | RenderProps` (the render-prop form). We forward
  // whatever the caller passed; antd handles both shapes at runtime.
  const forwarded = props as Omit<FormProps<Values>, 'children'> & {
    children?: React.ReactNode;
  };

  return (
    <AntForm<Values> {...forwarded} className={clsx('wk-form', className)} />
  );
};

Form.Item = AntForm.Item;
Form.List = AntForm.List;
Form.useForm = AntForm.useForm;
Form.useFormInstance = AntForm.useFormInstance;
Form.useWatch = AntForm.useWatch;
Form.Provider = AntForm.Provider;
Form.ErrorList = AntForm.ErrorList;
